// extracted by mini-css-extract-plugin
export default {"card":"ResultCard_card__MVQ-b","name":"ResultCard_name__jPOY6"};